export const goToApp = (
  appId: string,
  route: string = 'home',
  openInNewTab: boolean = false,
) => {
  const baseUrl = 'https://dev.wix.com/apps';
  const url = `${baseUrl}/${appId}/${route}`;

  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    window.location.assign(url);
  }
};
